/**
 * @function getDiffTimeFromNow
 * @description This function calculates the time difference between the current date and a specified target date.
 * @param targetTime accepts a number in millisecond
 * @returns A number in the millisecond
 */

export const getDiffTimeFromNow = (targetTime: number) => new Date().getTime() - targetTime;
